import React, { createContext, useContext, useEffect } from 'react';
import { getUiVersion } from './version';

const UiContext = createContext({ version: 'v1' });

export const useUi = () => useContext(UiContext);

export const UiProvider = ({ children }) => {
  const version = getUiVersion();
  
  useEffect(() => {
    // Apply theme class to body
    document.body.classList.remove('theme-v1', 'theme-v2');
    document.body.classList.add(`theme-${version}`);
  }, [version]);
  
  return (
    <UiContext.Provider value={{ version, isV2: version === 'v2' }}>
      {children}
    </UiContext.Provider>
  );
};
